import { useQuery } from "@tanstack/react-query";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import { getStaffApi } from "../api/staffApi";

export const useGetStaffQuery = (storeId: StoreId | null) => {
  return useQuery({
    queryKey: ["stores", storeId, "staff"],
    queryFn: () => getStaffApi(storeId!),
    enabled: !!storeId,
  });
};
